import { ChangeDetectionStrategy, Component, Input, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { BehaviorSubject, ReplaySubject, takeUntil } from 'rxjs'
  ;
import { ApiService } from '../../pages/sign-up/services/api.service';
import { ComingSoonPageTypeEnum } from '../../models/coming-soon-page.model';

@Component({
  selector: 'app-coming-soon-page',
  templateUrl: './coming-soon-page.component.html',
  styleUrls: ['./coming-soon-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ComingSoonPageComponent implements OnDestroy{

  readonly destroy$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  readonly successRequest$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public checkedValidControl: boolean = false;

  @Input() public title: string = 'COMING_SOON.MAIN_TITLE';
  @Input() public descr: string = 'COMING_SOON.MAIN_DESCR';
  @Input() public pageType: ComingSoonPageTypeEnum = ComingSoonPageTypeEnum.RETAIL;
  @Input() public img?: { en: string; de: string; at: string, folder: string };

  public subscriprionForm = this.formBuilder.group({
    email: ['', [Validators.email, Validators.required]]
  });

  constructor(
    private formBuilder: FormBuilder,
    private apiService: ApiService
  ) {
    this.emailControl.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(val => {
        this.emailControl.setValue(val.trim(), {emitEvent: false});
      })
  }

  public submitForm(): void {
    this.checkedValidControl = true;
    if (this.subscriprionForm.valid) {
      this.apiService.emailSubscription(this.emailControl.value, this.pageType)
        .pipe(takeUntil(this.destroy$))
        .subscribe((data) => {
          this.emailControl.reset();
          this.successRequest$.next(true);
        }, error => {
          if (error.error.data.hasOwnProperty('email')) {
            this.emailControl.markAsDirty();
            this.emailControl.markAllAsTouched();
            this.emailControl.setErrors([error.error.data.email[0]]);
          }
        })
    }
  }

  get emailControl(): FormControl { return this.subscriprionForm.get('email') as unknown as FormControl; }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

}
